import Sentry from "@similarweb/sentry-logger";

import { shouldShowComparisonBlankState } from "app/pages/industry-analysis/routes/routeUtils";
import { allTrackers } from "app/services/track/track";
import type { PageViewTrackingHandler } from "single-spa/react-app/router/IRouterState";
import { SwTrack } from "app/services/SwTrack";

export const marketAnalysisPlayersPageViewTracking: PageViewTrackingHandler = ({ toState, toParams }) => {
    try {
        const includeRegionalDomains = toParams.includeRegionalDomains === "true" ? "true" : "false";
        const extraParams: Record<string, string> = {
            regional_domains_state: includeRegionalDomains,
        };

        SwTrack.trackPageView(toState, { ...toParams, ...extraParams })
            .then(() => {
                if (shouldShowComparisonBlankState(toState.name, toParams.category as string | string[] | undefined)) {
                    allTrackers.dispatchTrackEvent("empty state", "page loaded", "MA Compare not supported");
                }
            })
            .catch((e) => {
                Sentry.error("marketAnalysisPlayersPageViewTracking: unable to track empty state event", e);
            });
    } catch (e) {
        Sentry.error("marketAnalysisPlayersPageViewTracking: unable to track page view", e);
    }
};

export const marketAnalysisPageViewTracking: PageViewTrackingHandler = ({ toState, toParams }) => {
    try {
        SwTrack.trackPageView(toState, toParams)
            .then(() => {
                if (shouldShowComparisonBlankState(toState.name, toParams.category as string | string[] | undefined)) {
                    allTrackers.dispatchTrackEvent("empty state", "page loaded", "MA Compare not supported");
                }
            })
            .catch((e) => {
                Sentry.error("marketAnalysisPageViewTracking: unable to track empty state event", e);
            });
    } catch (e) {
        Sentry.error("marketAnalysisPageViewTracking: unable to track page view", e);
    }
};
